module.exports = __webpack_public_path__ + "img/ry6.44abf320.png";